var AccordionTabsType;
(function (AccordionTabsType) {
    AccordionTabsType["ACCORDION"] = "accordion";
    AccordionTabsType["TABS"] = "tabs";
})(AccordionTabsType || (AccordionTabsType = {}));
var AccordionTabsAppearance;
(function (AccordionTabsAppearance) {
    AccordionTabsAppearance["DEFAULT"] = "default";
    AccordionTabsAppearance["FILTER"] = "filter";
    AccordionTabsAppearance["PIPELINE"] = "pipeline";
})(AccordionTabsAppearance || (AccordionTabsAppearance = {}));

export { AccordionTabsType as A, AccordionTabsAppearance as a };

//# sourceMappingURL=roche-accordion-tabs.types.js.map